import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'signup-revamp_field_change-keyboard_input';

/**
 * capture field name change (field name, value, page, sign up type)
 */
export function trackSignupRevampFieldChangeKeyboardInput(
  field_name_string: string,
  value_string2: string,
  page_string3: string,
  sign_up_type_string4: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: true,
    parameters: {
      field_name_string,
      value_string2,
      page_string3,
      sign_up_type_string4,
    },
  });
}
